module.exports = __webpack_public_path__ + "assets/6d63fe6dd4893456f2d9e3ec5bdb23a5.mp3";